import dataService from 'services/dataService';
import { API_PATIENT_KEY_NOTE } from 'services/dataService/resources';
import { showResult } from 'infrastructure/hooks/utils';

import type { IKeyNoteData } from 'infrastructure/interfaces';
import type { ModuleType } from 'infrastructure/enums';

interface IActionsKeyNotesProps {
  patientGuid: string;
  module: ModuleType;
  note?: string;
  expiresAt?: Date | null;
  showExpired: boolean;
}

export const saveKeyNotes = async ({
  patientGuid,
  module,
  note,
  expiresAt,
  showExpired,
}: IActionsKeyNotesProps) => {
  const url = API_PATIENT_KEY_NOTE(patientGuid);
  const value: Omit<IActionsKeyNotesProps, 'patientGuid'> = {
    module,
    note: note?.replace(/"/g, "'"),
    showExpired,
    expiresAt,
  };

  const { error, data } = await dataService.createOne<IKeyNoteData>(url, value);

  if (error) {
    showResult(error);
  }

  return data;
};
